import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SVGSearch from "static/svg/careers/search.svg";
import { StyledSearchInput } from "segments/desktop/careers/layouts/search-bar-careers/search-input/search-input.scss";
import Button from "segments/desktop/core-components/button/button";
import { REGULAR_BUTTON_TYPE } from "segments/desktop/core-components/button/button-consts";
const TEXT_PLACE_HOLDER = "Find your role, team, location";
const SEARCH_BUTTON_CTA = "Find your role";
const SearchInput = ({ value, onChange, onSearch })=>{
    const handleSearchInputKeyPress = (event)=>{
        event.key === "Enter" && onSearch();
    };
    return /*#__PURE__*/ _jsxs(StyledSearchInput, {
        className: "search-input",
        children: [
            /*#__PURE__*/ _jsx("input", {
                type: "search",
                value: value,
                onChange: (event)=>onChange(event.target.value),
                onKeyPress: handleSearchInputKeyPress,
                className: "input",
                placeholder: TEXT_PLACE_HOLDER,
                "aria-label": TEXT_PLACE_HOLDER
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "search-icon",
                children: /*#__PURE__*/ _jsx(SVGSearch, {})
            }),
            /*#__PURE__*/ _jsx(Button, {
                onClick: onSearch,
                buttonType: REGULAR_BUTTON_TYPE,
                isWithArrow: false,
                buttonText: SEARCH_BUTTON_CTA
            })
        ]
    });
};
export default SearchInput;
